

import React from 'react';

import GridContainer from '../../mui-components/Grid/GridContainer';
import ItemGrid from '../../mui-components/Grid/GridItem';
import RegularCard from '../../mui-components/Card/RegularCard';
import AssetSpreadsheetsTable from '../../containers/domain/asset-spreadsheet/AssetSpreadsheetsTable';

const AssetSpreadsheetsListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de planilhas de ativos"
        content={<AssetSpreadsheetsTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default AssetSpreadsheetsListingView;
